import { Group } from '@mantine/core';
import { useMantineTheme } from '@mantine/core';

const DotProgress = ({ items, size = 14, spacing = 18, keyName = 'postProductionThumb' }) => {
    const theme = useMantineTheme();
    const getColor = (item) => item[keyName] ? theme.colors.brand[4] : theme.colorScheme === 'dark' ? theme.colors.gray[7] : '#efefef';
    return (
        <Group style={{ marginLeft: 0, marginTop:4 }} spacing={4}>
            {items.map((item, index) => (
                <div key={index} style={{width:14, height:14, borderRadius:'100%', backgroundColor:getColor(item)}}></div>
                // <Indicator style={{zIndex: 0, height:2}}
                //     key={index}
                //     position='middle-start' 
                //     size={size} 
                //     color={getColor(item, index)}
                // />
            ))}
        </Group>
    );
};

export default DotProgress;